// The viewer's reduced-motion setting, followed as it changes: a page pauses
// its motion under it (cloud ADR 0393 §6.1, TOM-665).

import { useEffect, useState } from 'react';

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(
    () =>
      typeof window !== 'undefined' &&
      (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false)
  );
  useEffect(() => {
    if (typeof window === 'undefined' || window.matchMedia === undefined) return;
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const change = () => setReduced(query.matches);
    change();
    query.addEventListener('change', change);
    return () => query.removeEventListener('change', change);
  }, []);
  return reduced;
}
